import { OrganizationsService, useApiGetter } from '@localstack/services';
import { OrganizationRestrictionReason } from '@localstack/types';

export const useIsFreemiumHobbyCommercialMisuse = (): boolean => {
  const { data: orgRestrictions } = useApiGetter(OrganizationsService, 'listOrganizationRestrictions', [], {
    defaultValue: [],
  });

  return (
    orgRestrictions?.some((r) => r.reason === OrganizationRestrictionReason.FREEMIUM_HOBBY_COMMERCIAL_MISUSE) ?? false
  );
};
